<div class="se-app__footer" lang="en">
  <div *ngIf="organization.website_url">
    <a [href]="organization.website_url"
      class="pl-link"
      target="_blank"
      [attr.ga-action]="gaAttr('orgAction')"
      [attr.ga-label]="gaAttr('orgLabel')">
      Learn more about {{ organization.name }}
    </a> memberships
  </div>
  <div>
    <a
      [href]="loginUrl"
      class="pl-link"
      target="_blank"
      >View my account</a
    >
    |
    <a href="https://www.sportsengine.com/solutions/"
      class="pl-link"
      target="_blank"
      [attr.ga-action]="gaAttr('solutionsAction')"
      [attr.ga-label]="gaAttr('solutionsLabel')">What's SportsEngine?</a>
  </div>
  <div>
    Need Help?
    <a href="https://help.sportsengine.com/?smart-help"
      class="pl-link"
      target="_blank"
      [attr.ga-action]="gaAttr('helpAction')"
      [attr.ga-label]="gaAttr('helpLabel')">SportsEngine Help Center</a>
  </div>
</div>
